// extracted by mini-css-extract-plugin
export default {"header":"header-thIk2fxf","title":"title-ASBRGH87","body":"body-SPqUMGyH","announcement":"announcement-PKP_T58K"};